import firebase from 'firebase/app';
import axios from 'axios';
import { retryFailedApi } from './helpers';

async function checkIntegration(orgId) {
  const orgRef = firebase.firestore().collection('organizations').doc(orgId);
  const doc = await orgRef.get();

  if (!doc.exists) {
    throw new Error('No such organization found!');
  } else {
    const orgData = doc.data();
    const integrations = orgData.integrations || [];
    const hasIntegration = integrations.some(
      (integration) => integration.id === 'jXiFODBQ0WK0CUsqBbpi'
    );

    if (!hasIntegration) {
      throw new Error(
        'Please go to settings and authenticate with the OOCL integration.'
      );
    }

    return 'Integration check passed.';
  }
}

export const ooclProtocol = async ({ ref, container, orgId }) => {
  retryFailedApi();

  const integrationCheck = await checkIntegration(orgId);

  if (integrationCheck !== 'Integration check passed.') {
    throw new Error(integrationCheck);
  }

  const response = await axios({
    method: 'post',
    url: `${process.env.VUE_APP_DOMAIN}/api/v1/integrations/oocl/automate`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ref,
      container,
      orgId,
    },
  });

  return response;
};
